export const CATEGORY_LIST_REQUEST  = 'CATEGORY_LIST_REQUEST';
export const CATEGORY_LIST_SUCCESS  = 'CATEGORY_LIST_SUCCESS';
export const CATEGORY_LIST_FAIL     = 'CATEGORY_LIST_FAIL';